export default {"src":"/_next/static/media/landing-icon-twitter-14.10b7c528.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};